import React, { FC } from 'react';

import ArticlesCarousel from '@/components/articles-carousel/articles-carousel';
import { Article } from '@/types/article';

import styles from './roomstay-blog-related-articles.module.scss';
import Button from '@/components/button';
import { BLOG_HOME_PAGE } from '@/shared/constant';

export interface RoomstayBlogRelatedArticlesProps {
    articles?: Article[];
}

const RoomstayBlogRelatedArticles: FC<RoomstayBlogRelatedArticlesProps> = ({ articles }) => {
    if (!articles || articles.length === 0) {
        return null;
    }

    return (
        <div className={styles.root}>
            <div className={styles.title}>More articles</div>
            <ArticlesCarousel
                articles={articles || []}
                ArticleCardProps={{
                    dark: false,
                }}
            />
            <div className={styles.btnContainer}>
                <Button link={BLOG_HOME_PAGE}>MORE POSTS</Button>
            </div>
        </div>
    );
};

export default RoomstayBlogRelatedArticles;
